import { CANONICAL_ORIGIN } from "../config/seo.js";

type BreadcrumbOptions = {
  siteUrl?: string;
  title?: string;
};

function resolveSiteOrigin(siteUrl?: string) {
  if (siteUrl) {
    try {
      const parsed = new URL(siteUrl);
      if (
        parsed.hostname === "cosmetic.college" ||
        parsed.hostname === "www.cosmetic.college"
      ) {
        return CANONICAL_ORIGIN;
      }
      if (parsed.protocol === "https:" || parsed.protocol === "http:") {
        return parsed.origin;
      }
    } catch {
      // Fall back to the configured origin when content has no valid site URL.
    }
  }
  return CANONICAL_ORIGIN;
}

function formatSegment(segment: string) {
  return segment
    .replace(/-/g, " ")
    .replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase());
}

export function getBreadcrumbSchema(
  pathname?: string,
  options: BreadcrumbOptions = {}
) {
  if (!pathname) {
    return null;
  }

  const baseUrl = resolveSiteOrigin(options.siteUrl);
  const cleanedPath = pathname.split(/[?#]/)[0] || "/";
  const segments = cleanedPath.split("/").filter(Boolean);

  const itemListElement = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: `${baseUrl}/`,
    },
  ];

  if (segments.length === 0) {
    if (options.title) {
      itemListElement[0].name = options.title;
    }

    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement,
    };
  }

  segments.forEach((segment, index) => {
    const isLast = index === segments.length - 1;
    const isVtctSegment = segment === "vtct" && segments[0] === "courses";
    const name =
      isVtctSegment && !isLast
        ? "VTCT"
        : isLast && options.title
          ? options.title
          : formatSegment(segment);
    const itemPath = `/${segments.slice(0, index + 1).join("/")}/`;
    const itemUrl = new URL(itemPath, `${baseUrl}/`).href;

    itemListElement.push({
      "@type": "ListItem",
      position: index + 2,
      name,
      item: itemUrl,
    });
  });

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement,
  };
}
